import React from 'react'

import { get, isUndefined } from 'lodash'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { UrlQueryParamTypes, addUrlProps, multiReplaceInUrlQuery } from 'react-url-query'

import userPilotHelper, { useTrackUserPilotMovement } from 'common/user-pilot-helper'
import { selectAppProfile } from 'store/app-profile'

export class UserTrackingStartup extends React.Component {
  static propTypes = {
    children: PropTypes.node,
    user: PropTypes.object,
    appProfileConfig: PropTypes.object,
    referralScid: PropTypes.number,
    referralSource: PropTypes.string,
  }
  initialize() {
    const { user, referralScid, referralSource } = this.props
    const arg = { user }
    const params = {}
    if (referralScid) {
      arg.referralScid = referralScid
      params.referralScid = undefined
    }
    if (referralSource) {
      arg.referralSource = referralSource
      params.referralSource = undefined
    }
    const persistedSource = get(this.props.appProfileConfig, 'Source')
    if (!referralScid && !referralSource && persistedSource) {
      arg.referralSource = persistedSource
    }
    userPilotHelper.login(arg)
    multiReplaceInUrlQuery(params)
  }
  componentDidMount() {
    if (this.props.user) {
      this.initialize()
    }
  }
  componentDidUpdate(prevProps) {
    const user = this.props.user
    if (!isUndefined(user) && user.Id !== get(prevProps, 'user.Id')) {
      this.initialize()
    }
  }
  render() {
    return this.props.children
  }
}

export const ComponentWithPropsFromUrl = addUrlProps({
  urlPropsQueryConfig: {
    referralScid: {
      type: UrlQueryParamTypes.string,
      queryParam: 'referralScid',
    },
    referralSource: {
      type: UrlQueryParamTypes.string,
      queryParam: 'referralSource',
    },
  },
})(UserTrackingStartup)

const StoreConnectedUserTrackingStartup = connect((store) => ({
  user: store.user.record,
  appProfileConfig: selectAppProfile(store),
}))(ComponentWithPropsFromUrl)

const HookConnectedStoreConnectedUserTrackingStartup = (props) => {
  useTrackUserPilotMovement()
  return <StoreConnectedUserTrackingStartup {...props} />
}
export default HookConnectedStoreConnectedUserTrackingStartup
